var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.3438V8.71875M2.09375 4.71429C2.09375 2.65669 3.76637 1 5.84375 1C7.13779 1 8.27478 1.64285 8.94825 2.625M2.25 5.33333C1.5625 5.33333 1 5.89048 1 6.57143V12.7619C1 13.4429 1.5625 14 2.25 14H9.75C10.4375 14 11 13.4429 11 12.7619V6.57143C11 5.89048 10.4375 5.33333 9.75 5.33333H2.25Z",
    stroke: "#616874",
    strokeWidth: 1.38889,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.7442e3e7ebcf2702394a3a995f25915e.svg";
export { ForwardRef as ReactComponent };